export const personalDetails = [
    {
      label: "Name",
      value: "Ankur Srivastava",
    },
    {
      label: "Age",
      value: "23",
    },
    {
      label: "Address",
      value: "India",
    },
    {
      label: "Email",
      value: "ankursrivastava2070@gmail.com",
    },
    {
      label: "Contact No",
      value: "+91 7355446956",
    },
  ];
  
export  const jobSummary =
    "I am a dedicated technology enthusiast with a robust background in web development. I have created FagitAR, a webAR-based food ordering system using three.js, the MERN stack, PayPal, and TailwindCSS. I previously interned at Abhyaz, enhancing SEO and developing a CMS website. Until June 2024, I worked at Astarix, where I maintained the codebase and developed webAR-based solutions. Proficient in C++, C, Java, and Python, I also possess skills in ReactJS, Vite, APIs, and Docker. My participation in the 30 Days of Google Cloud Facilitator program has provided me with hands-on experience in Jenkins, Kubernetes, and Google Cloud Platform. Passionate about DevOps and cloud technologies, I am currently preparing for a ReactJS Developer role and writing an article on headless component libraries.";
  